import Component from './LatestUpdatesModal';
export default Component;

export const componentName = 'LatestUpdatesModal';
